import { Overlay as DsmOverlay } from '@pmi/dsm-react';
import { ComponentProps, useEffect, useRef } from 'react';

type OverlayProps = ComponentProps<typeof DsmOverlay>;

/**
 * Wraps dsm-react's Overlay: its OverlayModal toggles the body "modal-open" class from a
 * plain effect with no unmount cleanup, so if a consumer unmounts while the overlay is
 * still shown (e.g. a success/error handler that unmounts its parent right after an async
 * call resolves), the class is left stuck on <body>, breaking scroll for the rest of the
 * page. This removes it on unmount if that happens.
 */
export default function Overlay({
  variant,
  global,
  overlayColor,
  overlayOpacity,
  iconColor,
  show,
  fade,
  animated,
}: OverlayProps) {
  const showRef = useRef(show);
  showRef.current = show;

  useEffect(
    () => () => {
      if (showRef.current) {
        document.body.classList.remove('modal-open');
      }
    },
    [],
  );

  return (
    <DsmOverlay
      variant={variant}
      global={global}
      overlayColor={overlayColor}
      overlayOpacity={overlayOpacity}
      iconColor={iconColor}
      show={show}
      fade={fade}
      animated={animated}
    />
  );
}
